import type { CheckInType, EventStatus, SaleType } from '@linka/domain/enums';
import { useAtomValue } from 'jotai';
import { useParams, useSearchParams } from 'react-router';
import type { ExportFilters } from './components';
import { ExportFlow, ExportProvider } from './components';
import { dashboardFiltersAtom } from './filters';

interface ExportFlowWrapperProps {
  userEmail?: string;
}

export const ExportFlowWrapper = ({ userEmail }: ExportFlowWrapperProps) => {
  const { eventId = '' } = useParams();
  const [searchParams] = useSearchParams();
  const dashboardFilters = useAtomValue(dashboardFiltersAtom);

  const filters: ExportFilters = {
    status: (searchParams.get('status') as EventStatus) ?? undefined,
    type: (searchParams.get('type') as CheckInType) ?? undefined,
    saleType: (searchParams.get('saleType') as SaleType) ?? undefined,
    ...dashboardFilters,
  };

  return (
    <ExportProvider eventId={eventId} filters={filters} userEmail={userEmail}>
      <ExportFlow />
    </ExportProvider>
  );
};
